<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill">
        <dx-data-grid
            #dataGrid
            [dataSource]="purchaseOrderLines"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="job.jobNumber" caption="Job #" cellTemplate="linkTemplate" width="100"></dxi-column>
            <dxi-column dataField="job.customerName" caption="Customer" width="150"></dxi-column>
            <dxi-column dataField="invoiceDate" caption="Date" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="vendor" caption="Vendor" cellTemplate="editTemplate" width="150"></dxi-column>
            <dxi-column dataField="description" caption="Description" cellTemplate="editTemplate" width="300"></dxi-column>
            <dxi-column dataField="amount" caption="Amount" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-column>
            <dxi-column width="150"></dxi-column>

            <!-- <dxo-summary>
                <dxi-total-item column="linesTotal" summaryType="sum"  [valueFormat]="{ type: 'currency', precision: 2 }" displayFormat="Total: {0}" > </dxi-total-item>
            </dxo-summary> -->

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="purchase-order-search-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button type="button" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1" (click)="open(dataGrid.instance.getSelectedRowsData()[0].jobId)" class="btn btn-success">Open</button>
                <button type="button" (click)="addPurchaseOrder()" class="btn btn-secondary ml-2">New</button>
                <button type="button" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1" (click)="delete(dataGrid.instance.getSelectedRowsData()[0])" class="btn btn-danger ml-4">Delete</button>
            </div>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <a  [routerLink]="[]" (click)="open(cell.data.jobId)">{{ cell.value || '(blank)' }}</a>
            </div>

            <div *dxTemplate="let cell of 'editTemplate'">
                <a  [routerLink]="[]" (click)="addPurchaseOrder(cell.data)">{{ cell.value || '(blank)' }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="purchaseOrderLines" class="mr-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
